import FormattedMessage from 'I18n/components/FormattedMessage';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { HIGHLIGHT_CREATED_DATE } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatedDate = ({
  value
}) => /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
  "data-test-id": HIGHLIGHT_CREATED_DATE,
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "highlightCard.propertyLabels.created"
  }),
  value: value
});
export default CreatedDate;